export function containValue(val: number, min: number, max: number) {
  return val > max ? max : val < min ? min : val;
}
